import type { Environment, WeGivePayConfig } from './types'

/** Per-environment WeGive endpoints, baked into the bundle. The SDK ships as a
 *  single static artifact served from any CDN/domain, so the environment is
 *  resolved at runtime — never at build time. Explicit `apiBase` / `popupUrl`
 *  on the config still win, for self-hosting and tests. */
const API_BASE: Record<Environment, string> = {
  live: 'https://api.wegive.com',
  sandbox: 'https://api.sandbox.wegive.com',
}

const POPUP_URL: Record<Environment, string> = {
  live: 'https://pay.wegive.com',
  sandbox: 'https://pay.sandbox.wegive.com',
}

/** Resolve live vs sandbox. This is an explicit choice (`config.environment`),
 *  defaulting to `live`. It is deliberately NOT inferred from the key prefix:
 *  key mode (`pk_test_` / `pk_live_`) is orthogonal to environment — a test key
 *  can be issued within the prod environment. */
export function resolveEnvironment(config: WeGivePayConfig): Environment {
  return config.environment ?? 'live'
}

export function resolveApiBase(config: WeGivePayConfig): string {
  return config.apiBase ?? API_BASE[resolveEnvironment(config)]
}

export function resolvePopupUrl(config: WeGivePayConfig): string {
  return config.popupUrl ?? POPUP_URL[resolveEnvironment(config)]
}
